function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import applyReducer from './applyReducer';
import notificationConstants from '../constants/notificationConstants';
const initState = {
  list: []
};
const addBlockingNotification = (state, {
  content,
  settings
}) => _objectSpread(_objectSpread({}, state), {}, {
  list: [...state.list, {
    id: content.id,
    content,
    settings,
    type: 'modal'
  }]
});

/* newest = bottom right
 * If there's an existing message with a specified id, it will be updated and moved
 *   to the bottom of the list.
 * Also, new messages are always added to the bottom of the list
 */
const addNotification = (state, {
  content,
  settings
}) => {
  // check the state.list for an entity with same content id, then update it
  const updateIndex = state.list.findIndex(x => x.id === content.id);
  if (updateIndex > -1) {
    // remove the old one - then add back to the list at the top
    state.list.splice(updateIndex, 1);
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    // new messages always on the bottom
    list: [...state.list, {
      id: content.id,
      content,
      settings,
      type: 'toast'
    }]
  });
};
const removeNotification = (state, {
  id
}) => _objectSpread(_objectSpread({}, state), {}, {
  // clear the list if the id has not been defined
  list: id === undefined ? [] : state.list.filter(note => note.id !== id)
});
const reducers = {
  [notificationConstants.CREATE]: addNotification,
  [notificationConstants.CREATE_MODAL]: addBlockingNotification,
  [notificationConstants.DISMISS]: removeNotification
};

// does applyReducer take care of combining reducers? I think so...
export default applyReducer(reducers, initState);